import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _objectSpread from "@babel/runtime/helpers/objectSpread";

var getChildRouterPaths = function getChildRouterPaths(routers) {
  return routers.map(function (router) {
    return router.path;
  });
};

function resovleComonent(router) {
  var wrap = [];

  function resolve(router, basePath) {
    if (router.components.length > 0) {
      router.components.forEach(function (component) {
        wrap.push(_objectSpread({
          path: "".concat(basePath, "/").concat(component.name),
          component: component.component
        }, component.options));
      });
    }

    if (router.routers.length > 0) {
      router.routers.forEach(function (childRouter) {
        resolve(childRouter, basePath + childRouter.path);
      });
    }
  }

  resolve(router, router.path);
  return wrap;
}

var MyComponent = function MyComponent(name, component) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  _classCallCheck(this, MyComponent);

  this.name = name;
  this.component = component;
  this.options = options;
};

var MyRouterResolver = function () {
  function MyRouterResolver() {
    _classCallCheck(this, MyRouterResolver);

    this.path = '';
    this.routers = [];
    this.components = [];
  }

  _createClass(MyRouterResolver, [{
    key: "setPath",
    value: function setPath(path) {
      this.path = path;
    }
  }, {
    key: "hasExistPath",
    value: function hasExistPath(path) {
      return getChildRouterPaths(this.routers).includes(path);
    }
  }, {
    key: "hasExistComponent",
    value: function hasExistComponent(componentName) {
      var componentsName = this.components.map(function (component) {
        return component.name;
      });
      return componentsName.includes(componentName);
    }
  }, {
    key: "use",
    value: function use(path, router) {
      if (!(router instanceof MyRouterResolver)) {
        throw new TypeError('router 不是 MyRouterResolver 的实例对象');
      }

      if (this.hasExistPath(path)) {
        throw new Error('当前path已经被设置');
      }

      router.setPath(path);
      this.routers.push(router);
    }
  }, {
    key: "addComponent",
    value: function addComponent(componentName, component, options) {
      if (this.hasExistComponent(componentName)) {
        throw new Error('当前组件列表 已经存在该组件' + componentName);
      }

      this.components.push(new MyComponent(componentName, component, options));
    }
  }, {
    key: "resolverAll",
    value: function resolverAll() {
      return resovleComonent(this);
    }
  }]);

  return MyRouterResolver;
}();

export default function () {
  return new MyRouterResolver();
}